import React from 'react';
import {connect} from 'react-redux';
import {Field, reduxForm, formValueSelector} from 'redux-form';
import {setPostalCode} from '../redux/modules/postalCode';
import {setInstitution} from '../redux/modules/institution';
import {setDepartment} from '../redux/modules/department';

const selector = formValueSelector('gratisForm');

const select = ({input, meta, handleChange, ...other}) =>
    <select onChange={evt => {
        handleChange(evt);
        input.onChange(evt)
    }} {...other}/>
;

function difference(whole, sub) {
    let rv = [];
    for (let w in whole) {
        let add = true;
        for (let s in sub) {
            if (whole[w].value === sub[s].name) {
                add = false;
                break;
            }
        }
        if (add) rv.push(whole[w]);
    }
    return rv;
}

class AccountInformation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {readOnly: false};
        this.enablePostalCodeSearch = this.enablePostalCodeSearch.bind(this);
        this.selectDepartment = this.selectDepartment.bind(this);
        this.selectInstitution = this.selectInstitution.bind(this);
        this.search = this.search.bind(this);
    }

    enablePostalCodeSearch(evt) {
    evt.preventDefault();
        this.setState(prevState => ({readOnly: false}));
          if (evt.target.value.length > evt.target.maxLength) {
                              evt.target.value = evt.target.value.slice(0, evt.target.maxLength);
          }
    }

    search(evt) {
        if (evt.target.value.length > 1 && evt.target.value.length <= evt.target.maxLength) {
         if (evt.target.value.length > evt.target.maxLength) {
                  evt.target.value = evt.target.value.slice(0, evt.target.maxLength);
          }
            this.props.dispatch(setPostalCode(evt.target.value));
        }
    }

    selectInstitution(evt) {
        this.props.dispatch(setInstitution(evt.target.value));
        this.setState(prevState => ({readOnly: true}));
    }

    selectDepartment(evt) {
        this.props.dispatch(setDepartment(evt.target.value));
        this.setState(prevState => ({readOnly: true}));
    }

    render() {
        if (!this.props.visible) return null;
        const {departments, institutions, formValues, office} = this.props;
        const {department, departmentName, institution, postalCode} = formValues;
        const showOtherDepts = (department === 'other');
        const otherInstitution = (institution === 'other');
        const dispatch = this.props.dispatch;
        const style = this.props.errorStyle;
        return (
            <fieldset>
                <legend>University Information</legend>
                <div className="gratisRequestInstructions"
                     dangerouslySetInnerHTML={{__html: this.props.office.config.gratisRequestInstructions}}>
                </div>
                <div className="paragraph">
                    <label htmlFor="postalCodeSearch">Institution Postal Code <span
                        className="requiredAsterisk">*</span>
                    </label>
                    <Field name="postalCodeSearch" component="input" type={this.props.office.code === "us" ? "number" : "text"}
                           value="" onChange={this.search} onFocus={this.enablePostalCodeSearch} onBlur={this.enablePostalCodeSearch}
                           size="10" maxLength="10" min="1" readOnly={this.state.readOnly}/>
                </div>
                <div id="accountSelector">
                    <div id="institutionInputGroup">
                        <div className="paragraph">
                            <label htmlFor="institution">Institution Name <span className="requiredAsterisk">*</span>
                            </label>
                            <Field name="institution" component={select}
                                   handleChange={this.selectInstitution}>
                                <option value=""> -- Please Select --</option>
                                {
                                    institutions && institutions.map((e, i) =>
                                        <option key={i} value={e.id} selected={institution === e.id ? 'selected' : ''}>{e.name}</option>
                                    )
                                }
                                <option value="other">Other institution</option>
                            </Field>
                        </div>
                    </div>
                    {!otherInstitution &&
                    <div id="departmentInputGroup">
                        <div className="paragraph">
                            <label htmlFor="department">Department <span className="requiredAsterisk">*</span>
                            </label>
                            <Field name="department" component={select}
                                   handleChange={this.selectDepartment}>
                                <option value=""> -- Please Select --</option>
                                {
                                    departments && departments.map((e, i) =>
                                        <option key={i} value={e.id} selected={department === e.id ? 'selected' : ''}>{e.name}</option>
                                    )
                                }
                                <option value="other">Other department ... [Select below]</option>
                            </Field>
                        </div>
                        {showOtherDepts &&
                        <div className="paragraph" id="userSuppliedDepartmentInput">
                            <label htmlFor="departmentName">&nbsp;</label>
                            <Field name="departmentName" component="select">
                                <option value=""> -- Please Select --</option>
                                {difference(office.values.departmentNames, departments).map((e, i) =>
                                    <option key={i} value={e.value}>{e.label}</option>
                                )}
                            </Field>
                            <div className="gratisRequestInstructions">
                                <div className="paragraph">Please select the most appropriate
                                    department name from the list above.
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                    }
                </div>
                {otherInstitution &&
                <div id="noAccountsMessage" style={{display: 'block'}}>
                    <div className="paragraph"
                         dangerouslySetInnerHTML={{__html: this.props.office.config.noAccountsMessage}}>
                    </div>
                </div>
                }
            </fieldset>
        );
    }
}

export default connect(state => ({
    ...state,
    formValues: selector(state, 'department', 'departmentName', 'institution', 'postalCode')
}))(AccountInformation);


// WEBPACK FOOTER //
// ./src/form/components/AccountInformation.jsx